import { BrowserRouter } from "react-router-dom";
import { Suspense } from "react";
import { ApolloProvider } from "@apollo/client";
import GamingLoading from "../components/common/GamingLoading/GamingLoading";
import RoutesLogged from "./RoutesLogged";
import { getCurrentToken, selectKcReady } from "@onmo/auth";
import { createApolloClient } from "@onmo/graphql";
import { ScrollRestoration } from "../components/common/ScrollRestoration";
import RoutesWrapper from "./RoutesWrapper";
import { Snackbar } from "../components/core/Snackbar/Snackbar";
import { useAppSelector } from "../components/hooks";
import { HtmlGameProvider } from "@onmo/html-game";

const Routing = () => {
  const apolloClient = createApolloClient(getCurrentToken() ?? "");
  const kcReady = useAppSelector(selectKcReady);

  if (!kcReady) return <GamingLoading />;

  return (
    <Suspense fallback={<GamingLoading />}>
      <ApolloProvider client={apolloClient}>
        <BrowserRouter>
          <ScrollRestoration />
          <Snackbar />
          <RoutesWrapper>
            <HtmlGameProvider>
              <RoutesLogged />
            </HtmlGameProvider>
          </RoutesWrapper>
        </BrowserRouter>
      </ApolloProvider>
    </Suspense>
  );
};

export default Routing;
